import { createSvgComponent } from "../../icon/createSvgComponent";
import Delete from "@core/__generated__/icon/figma/delete.svg";
export default createSvgComponent(Delete);